import React, { useState } from 'react';
import { BookOpen, Users, Building, Clock, Grid } from 'lucide-react';
import '../styles/PlanningData.css';

// Import smaller planning components
import SubjectItemLoad from './planning/SubjectItemLoad';
import ClassSubjectItemLoad from './planning/ClassSubjectItemLoad';
import ClassSubjectItemQuota from './planning/ClassSubjectItemQuota';
import TeacherDetails from './planning/TeacherDetails';
import RoomsDetails from './planning/RoomsDetails';
import DoubleLessonsDetails from './planning/DoubleLessonsDetails';

const PlanningData = ({ onNext }) => {
  const [currentPlanning, setCurrentPlanning] = useState('subject-load');
  
  const planningTabs = [
    { id: 'subject-load', name: 'Subject Item Load', icon: BookOpen },
    { id: 'class-subject-load', name: 'Class Subject Item Load', icon: Users },
    { id: 'class-subject-quota', name: 'Class Subject Item Quota', icon: Grid },
    { id: 'teacher-details', name: 'Teacher Details', icon: Users },
    { id: 'rooms', name: 'Rooms Details', icon: Building },
    { id: 'double-lessons', name: 'Double Lessons Details', icon: Clock }
  ];

  const renderCurrentPlanning = () => {
    switch (currentPlanning) {
      case 'subject-load':
        return <SubjectItemLoad />;
      case 'class-subject-load':
        return <ClassSubjectItemLoad />;
      case 'class-subject-quota':
        return <ClassSubjectItemQuota />;
      case 'teacher-details':
        return <TeacherDetails />;
      case 'rooms':
        return <RoomsDetails />;
      case 'double-lessons':
        return <DoubleLessonsDetails />;
      default:
        return <SubjectItemLoad />;
    }
  };

  return (
    <div className="planning-data-container">
      {/* Header Section */}
      <div className="planning-data-header">
        <div className="planning-data-header-content">
          <div className="planning-data-icon-container">
            <BookOpen className="planning-data-icon" size={24} />
          </div>
          <div className="planning-data-title-section">
            <h3 className="planning-data-title">計劃資料 (Planning Data)</h3>
            <p className="planning-data-subtitle">課節分配、教師與課室編配</p>
          </div>
        </div>
      </div>

      {/* Planning Navigation */}
      <div className="planning-data-navigation">
        <div className="planning-data-tabs-container">
          {planningTabs.map(tab => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setCurrentPlanning(tab.id)}
                className={`planning-data-tab ${currentPlanning === tab.id ? 'active' : ''}`}>
                <div className="planning-data-tab-icon">
                  <Icon size={18} />
                </div>
                <span className="planning-data-tab-text">{tab.name}</span>
                {currentPlanning === tab.id && (
                  <div className="planning-data-tab-indicator"></div>
                )}
              </button>
            );
          })}
        </div>
      </div>

      {renderCurrentPlanning()}

      <div className="flex justify-between items-center pt-6 border-t border-gray-200">
        <button className="px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-all duration-200 font-medium">
          關閉 (Close)
        </button>
        <div className="flex space-x-3">
          <button className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all duration-200 font-medium">
            編修 (Modify)
          </button>
          <button className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-all duration-200 font-medium">
            儲存 (Save)
          </button>
          <button 
            onClick={() => onNext('generation')}
            className="px-6 py-3 bg-gradient-to-r from-emerald-600 to-teal-600 text-white rounded-lg hover:from-emerald-700 hover:to-teal-700 transition-all duration-200 font-medium flex items-center">
            下一步：編製產生 (Next: Generation)
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlanningData;